import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {runInAction } from "mobx"
import {NEW_SEARCH_WIDGET} from "../new-search-widget.consts";
import type {NewSearchWidgetState} from "../models/new-search-widget.state";
import {debounce} from "../../../infrastructure/debounce/debounce";
import type {NewSearchWidgetController} from "../new-search-widget.controller";

export class NewSearchWidgetChangeQueryHandler extends ActionHandler {
  controller: NewSearchWidgetController;
  state: NewSearchWidgetState;
  type = NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onChangeQuery;

  static injectables = [...ActionHandler.injectables];

  constructor() {
    super();

    this.fetch = debounce((params) => this.controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.FETCH.onSearchFetch, params), 250);
  }

  async action(params) {
    runInAction(() => {
      this.state.query = params.query;
      this.controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onTabClick, {reset: true})
    })

    if(!params.query || params.query === '' || params.query?.length === 0) {
      this.state.queryStatus = NEW_SEARCH_WIDGET.ANALYTICS.SEARCH_STATUS.deleted;
      await this.controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onSportTypeMenuClick, {isOpen: false})
      await this.controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onSportTypeClick, {id: NEW_SEARCH_WIDGET.allSportsId, source: this.controller.config.source, isReset: true})
      await this.controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.RESET.onSearchReset, {fullReset: true})
    }
    else if(params.query?.length > 0) {
      this.state.queryStatus = NEW_SEARCH_WIDGET.ANALYTICS.SEARCH_STATUS.hasQuery;
    }
    if(params.query?.length > NEW_SEARCH_WIDGET.minimumCharacters) {
      await this.fetch(params)
    }
  }
}
